module.exports = __webpack_public_path__ + "static/zs-101b557052f8908d317506491cd720a5.png";